// Normaliza un idCentro para compararlo de forma robusta.
// Maneja padding con ceros ("09" === "9"), tipos mezclados (number vs string)
// y valores falsy (null/undefined/"" devuelven null).
export const normalizarIdCentro = (valor) => {
  if (valor == null || valor === "") return null;
  const num = parseInt(valor, 10);
  return Number.isNaN(num) ? null : num;
};

// Compara dos idCentros de forma robusta.
export const mismoCentro = (a, b) => {
  const na = normalizarIdCentro(a);
  const nb = normalizarIdCentro(b);
  return na !== null && nb !== null && na === nb;
};
